import React from 'react'
import styled from 'styled-components'

import { PairInformationCurrency } from '@root/entities/pair/ui'

import type { PairPerformance } from '../../model'

type Props = {
  value: PairPerformance
}

export const DistributeTableCurrencyCell: React.FC<Props> = React.memo(
  ({ value }) => (
    <Root>
      <PairInformationCurrency
        pair={value.pair}
        withSocials
        withAge
        withProvider
        withBoosters
        withDevTokens
      />
    </Root>
  ),
)

const Root = styled.div`
  display: grid;
  gap: 6px;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  padding-inline-end: 8px;
`
